module.exports = __webpack_public_path__ + "img/xm1014.d3181704.svg";